import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "subheader-block ml-auto demo" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "subheader col-6" }, [
        _createElementVNode("h1", { class: "subheader-title" }, "来期見通しデータ作成")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          disabled: _ctx.btnDisable,
          class: "btn btn-primary waves-effect waves-themed"
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("span", { class: "fal fa-upload mr-1" }, null, -1),
          _createTextVNode("インポート ")
        ]), 8, _hoisted_4),
        _createElementVNode("button", {
          type: "button",
          disabled: _ctx.btnDisable,
          class: "btn btn-primary waves-effect waves-themed"
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1),
          _createTextVNode("エクスポート ")
        ]), 8, _hoisted_5)
      ])
    ])
  ]))
}